export var listaUf = [
    {
        descricao: "ACRE",
        sigla: "AC",
    },
    {
        descricao: "ALAGOAS",
        sigla: "AL",
    },
    {
        descricao: "AMAPA",
        sigla: "AP",
    },
    {
        descricao: "AMAZONAS",
        sigla: "AM",
    },
    {
        descricao: "BAHIA",
        sigla: "BA",
    },
    {
        descricao: "CEARA",
        sigla: "CE",
    },
    {
        descricao: "DISTRITO FEDERAL",
        sigla: "DF",
    },
    {
        descricao: "ESPIRITO SANTO",
        sigla: "ES",
    },
    {
        descricao: "GOIAS",
        sigla: "GO",
    },
    {
        descricao: "MARANHAO",
        sigla: "MA",
    },
    {
        descricao: "MATO GROSSO",
        sigla: "MT",
    },
    {
        descricao: "MATO GROSSO DO SUL",
        sigla: "MS",
    },
    {
        descricao: "MINAS GERAIS",
        sigla: "MG",
    },
    {
        descricao: "PARA",
        sigla: "PA",
    },
    {
        descricao: "PARAIBA",
        sigla: "PB",
    },
    {
        descricao: "PARANA",
        sigla: "PR",
    },
    {
        descricao: "PERNAMBUCO",
        sigla: "PE",
    },
    {
        descricao: "PIAUI",
        sigla: "PI",
    },
    {
        descricao: "RIO DE JANEIRO",
        sigla: "RJ",
    },
    {
        descricao: "RIO GRANDE DO NORTE",
        sigla: "RN",
    },
    {
        descricao: "RIO GRANDE DO SUL",
        sigla: "RS",
    },
    {
        descricao: "RONDONIA",
        sigla: "RO",
    },
    {
        descricao: "RORAIMA",
        sigla: "RR",
    },
    {
        descricao: "SANTA CATARINA",
        sigla: "SC",
    },
    {
        descricao: "SAO PAULO",
        sigla: "SP",
    },
    {
        descricao: "SERGIPE",
        sigla: "SE",
    },
    {
        descricao: "TOCANTINS",
        sigla: "TO",
    },
];
